import {atom} from 'recoil';

export const ModalAtomState = atom({
    key:'ModalAtom',
    default: {
        ModalName:'PopupBase', 
        Page:<></>, 
        isHide:false, 
        isCancel:false, 
        Height:0, 
        Title: ""},
});


export const ListAtomState=atom({
    key:'ListAtom',
    default:[],
});

export const DisplayListAtomState=atom({
    key:'DisplayListAtom',
    default:['인프라'],
});

export const ThemeAtomState = atom({
    key: 'ThemeAtom',
    default: localStorage.getItem('estimate-theme') || 'light',
});

// 견적 마법사 현재 단계 (1=그룹 선택, 2=개발환경, 3=기능 선택, 4=견적 확인)
export const CurrentStepAtomState = atom({
    key: 'CurrentStepAtom',
    default: 1,
});

// 견적에 포함하기로 선택한 그룹 std_key 배열 (1단계 결과)
export const SelectedGroupsAtomState = atom({
    key: 'SelectedGroupsAtom',
    default: ['infraSetting'],
});